"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _units = require("../../theme/units");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StyledDescriptionList = _styledComponents["default"].dl.withConfig({
  displayName: "DescriptionList__StyledDescriptionList",
  componentId: "n6wk2d-0"
})(["padding:", ";margin:", ";"], _units.globalSizes.small, _units.globalSizes.small);
/**
 *
 * ### Blue Prism styled `DescriptionList` component
 *
 * The **DescriptionList** is used by the **Summary** component and renders a `<dl>` element to the dom. It should be passed either the **Term** or **Description** components as its children.
 */


var DescriptionList = function DescriptionList(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledDescriptionList, null, children);
};

var _default = DescriptionList;
exports["default"] = _default;